import axios from 'axios';
import { CommonCodeCategory, IPreSignedUrlResponse, TUploadImageParams } from 'interfaces/common';
import { getUploadContentType } from 'utils/fileUtils';
import * as logsUtils from 'utils/logsUtils';
import { storeClient } from './apiClients';
import { postPreSignedUrl } from './store';

// 공통코드 트리 조회 — 서버가 '사용중'인 카테고리와 하위 코드만 내려줌
export const getCommonCodes = async (): Promise<CommonCodeCategory[]> => {
  const { data } = await storeClient.get('/common/codes');
  return data;
};

// pre-signed URL 발급 → S3 PUT 업로드 후, 등록 API에 넘길 uploadedFileUrl 반환
export const uploadImageByPreSignedUrl = async ({
  serviceName,
  storeId,
  file,
  fileName
}: TUploadImageParams): Promise<string> => {
  const { preSignedUrl, uploadedFileUrl }: IPreSignedUrlResponse = await postPreSignedUrl({
    serviceName,
    fileName,
    pathVariable: { storeId }
  });

  try {
    // storeClient가 아닌 기본 axios — 서명 URL 요청에 인증 헤더가 붙으면 안 된다
    await axios.put(preSignedUrl, file, { headers: { 'Content-Type': getUploadContentType(fileName) } });
  } catch (error) {
    logsUtils.errorLogger(`[PRESIGNED-IMAGE-UPLOAD-ERROR]: ${error?.response?.data}`, {
      'ui-args': { serviceName, fileName, fileSize: file.size, preSignedUrl: preSignedUrl?.split('?')[0] }
    });
    throw new Error('이미지 업로드에 실패했습니다. 잠시 후 다시 시도해주세요.');
  }

  return uploadedFileUrl;
};
